export enum ToastrType {
    error,
    info,
    success,
    warning,
}
